import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircleIcon from '@mui/icons-material/Circle';

const ProfileStatusLegend = () => (
  <Box
    mt={2}
    p={1.5}
    border={1}
    borderColor='divider'
    borderRadius={1.5}
    bgcolor='#fafafa'
  >
    <Box display='flex' alignItems='flex-start' gap={1} mb={1}>
      <CheckCircleIcon sx={{ fontSize: 16, color: '#2e7d32', mt: 0.2 }} />
      <Typography variant='caption' color='text.secondary' sx={{ lineHeight: 1.45 }}>
        <Box component='span' fontWeight={700} color='#2e7d32'>
          Reviewed
        </Box>{' '}
        You have opened this card, or saved an edit, and it is within its limit.
      </Typography>
    </Box>
    <Box display='flex' alignItems='flex-start' gap={1}>
      <CircleIcon sx={{ fontSize: 10, color: '#1976d2', mt: 0.55, ml: 0.35, mr: 0.4 }} />
      <Typography variant='caption' color='text.secondary' sx={{ lineHeight: 1.45 }}>
        <Box component='span' fontWeight={700} color='#1976d2'>
          Generated
        </Box>{' '}
        Created from your sources. Open it to mark it reviewed.
      </Typography>
    </Box>
    <Box display='flex' alignItems='flex-start' gap={1} mt={1}>
      <CircleIcon sx={{ fontSize: 10, color: '#64748b', mt: 0.55, ml: 0.35, mr: 0.4 }} />
      <Typography variant='caption' color='text.secondary' sx={{ lineHeight: 1.45 }}>
        <Box component='span' fontWeight={700} color='#64748b'>
          Empty
        </Box>{' '}
        No points yet. You can add some.
      </Typography>
    </Box>
    <Box display='flex' alignItems='flex-start' gap={1} mt={1}>
      <CircleIcon sx={{ fontSize: 10, color: '#c2410c', mt: 0.55, ml: 0.35, mr: 0.4 }} />
      <Typography variant='caption' color='text.secondary' sx={{ lineHeight: 1.45 }}>
        <Box component='span' fontWeight={700} color='#c2410c'>
          Too long
        </Box>{' '}
        Over the character limit. Shorten it and save before it can be used.
      </Typography>
    </Box>
  </Box>
);

export default ProfileStatusLegend;
